import React, { Component, useState, useEffect, useRef } from "react";
import { login, logout } from '../../flux/actions/authActions';
import { connect } from 'react-redux';
import { clearErrors } from '../../flux/actions/errorActions';
import { ILoginForm, IAuthReduxProps } from '../../types/interfaces';
import { useHistory, useParams } from 'react-router-dom';
import { useAlert } from "react-alert";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

// export default class Login extends Component {
const LoginForm = ({
    isAuthenticated,
    redirectTo,
    error,
    login,
    logout,
    clearErrors
  }: ILoginForm) => {
    // logout();
    const history = useHistory();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const usernameRef = useRef<HTMLInputElement>(document.createElement("input"));
    const passwordRef = useRef<HTMLInputElement>(document.createElement("input"));
    // const [values, setValues] = useState({username: 'A.LAAZAZI', password: 'd-d-'});
    const [values, setValues] = useState({username: '', password: ''});
    const [rememberMe, setRememberMe] = useState(false);
    const [errors, setErrors] = useState({});
    const [errorMessage, setError] = useState(null);
    const alert = useAlert();

    let { redirect } = useParams();
    console.log("redirect", redirect)

    useEffect(() => {
      if(error.id === "LOGIN_FAIL"){
        alert.error(error.msg.msg);
        setDisableSubmit(false);
      }
    }, [error])

    const usernameValidation = username => {
        if (username.trim() === ''){
          alert.error('Nom de compte vide');
          return `Nom de compte vide`;
        }
        return null;
    };

    const passwordValidation = password => {
        if (password.trim() === ''){
          alert.error('Mot de passe vide');
          return `Mot de passe vide`;
        }
        return null;
    };

    const validate = {
        username: usernameValidation,
        password: passwordValidation,
    };

    const handleChange = evt => {
        const { name, value: newValue, type } = evt.target;
        
        // keep number fields as numbers
        const value = type === 'number' ? +newValue : newValue;
        
        // save field values
        setValues({
          ...values,
          [name]: value,
        });
    };

    const handleRememberMe = evt => {
        setRememberMe(evt.target.checked);
    };

    useEffect(() => {
      setRememberMe(localStorage.getItem("ZRkOdwVoWw3ZpldosA6RS1G2oTIO1ydZEyBP2G91I8pbH2OrQ5ySftsoXcQ8") === "yes" ? true : false)
      if(localStorage.getItem("Z67jSeR2elTu91C6HCktIf7GgFuFgMSp785R3CrHTUVm9vFgsQUTjtFGyozDW25NQQVnaOVks2tRasyxV26wgsjfROADNBZOr4u") !== null && localStorage.getItem("Z67jSeR2elTu91C6HCktIf7GgFuFgMSp785R3CrHTUVm9vFgsQUTjtFGyozDW25NQQVnaOVks2tRasyxV26wgsjfROADNBZOr4u") !== undefined){
        setValues({...values, username: localStorage.getItem("Z67jSeR2elTu91C6HCktIf7GgFuFgMSp785R3CrHTUVm9vFgsQUTjtFGyozDW25NQQVnaOVks2tRasyxV26wgsjfROADNBZOr4u") || ""});
        passwordRef.current && passwordRef.current.focus();
      }
      else
        usernameRef.current && usernameRef.current.focus();
      
      if(localStorage.getItem("prJkCZ9g4HoKSPbO5ikvamwJ1x202nsR6nEamEZYns4kgfA05wPekQ") === null || localStorage.getItem("prJkCZ9g4HoKSPbO5ikvamwJ1x202nsR6nEamEZYns4kgfA05wPekQ") === undefined)
        localStorage.setItem("prJkCZ9g4HoKSPbO5ikvamwJ1x202nsR6nEamEZYns4kgfA05wPekQ", generateRandomString());
      if(localStorage.getItem("cKpDc5YxzQTxB0so9tzFz7Vo9LJkn0MjMqSQbhDM71i2QbGdBSxG") === null || localStorage.getItem("cKpDc5YxzQTxB0so9tzFz7Vo9LJkn0MjMqSQbhDM71i2QbGdBSxG") === undefined)
        localStorage.setItem("cKpDc5YxzQTxB0so9tzFz7Vo9LJkn0MjMqSQbhDM71i2QbGdBSxG", generateRandomString());
      if(localStorage.getItem("BmvXtokkKUFwQ0ybMIkInS3ZW3zwaNopLbmxFvQ6g2pdtEOKkEK12XwCjrltlBpeleEiRTNgOGeITSyxrkb1a13aQWcs") === null || localStorage.getItem("BmvXtokkKUFwQ0ybMIkInS3ZW3zwaNopLbmxFvQ6g2pdtEOKkEK12XwCjrltlBpeleEiRTNgOGeITSyxrkb1a13aQWcs") === undefined)
        localStorage.setItem("BmvXtokkKUFwQ0ybMIkInS3ZW3zwaNopLbmxFvQ6g2pdtEOKkEK12XwCjrltlBpeleEiRTNgOGeITSyxrkb1a13aQWcs", generateRandomString());
      if(localStorage.getItem("aN1osIqSa1wKv2YNei4ODujaoWpBTmQWDnsHCpAhsjISQj6WRUyaiM8bwVGN") === null || localStorage.getItem("aN1osIqSa1wKv2YNei4ODujaoWpBTmQWDnsHCpAhsjISQj6WRUyaiM8bwVGN") === undefined)
        localStorage.setItem("aN1osIqSa1wKv2YNei4ODujaoWpBTmQWDnsHCpAhsjISQj6WRUyaiM8bwVGN", generateRandomString());
      if(localStorage.getItem("G4vRcXUZjwSpecY522JCGShMzHMDeUqzdrAFOGW3slgX90h86B") === null || localStorage.getItem("G4vRcXUZjwSpecY522JCGShMzHMDeUqzdrAFOGW3slgX90h86B") === undefined)
        localStorage.setItem("G4vRcXUZjwSpecY522JCGShMzHMDeUqzdrAFOGW3slgX90h86B", generateRandomString());
      if(localStorage.getItem("GfZ5ioR4HNJ3047nviUX4MkfOoY5Ww00Zt2rEcBZGjiog7XxyfMyE") === null || localStorage.getItem("GfZ5ioR4HNJ3047nviUX4MkfOoY5Ww00Zt2rEcBZGjiog7XxyfMyE") === undefined)
        localStorage.setItem("GfZ5ioR4HNJ3047nviUX4MkfOoY5Ww00Zt2rEcBZGjiog7XxyfMyE", generateRandomString());
      if(localStorage.getItem("X4XBrT1CozKS9YBj7rrpd1UuZh6tPzGxp01WJAxeLDpaBU82oosXbuk4") === null || localStorage.getItem("X4XBrT1CozKS9YBj7rrpd1UuZh6tPzGxp01WJAxeLDpaBU82oosXbuk4") === undefined)
        localStorage.setItem("X4XBrT1CozKS9YBj7rrpd1UuZh6tPzGxp01WJAxeLDpaBU82oosXbuk4", generateRandomString());
      if(localStorage.getItem("Dco2fClCTetiiudWh0FFo4t9C51CyV7nLelg8FgjcCp6dfgzZbITq") === null || localStorage.getItem("Dco2fClCTetiiudWh0FFo4t9C51CyV7nLelg8FgjcCp6dfgzZbITq") === undefined)
        localStorage.setItem("Dco2fClCTetiiudWh0FFo4t9C51CyV7nLelg8FgjcCp6dfgzZbITq", generateRandomString());
      if(localStorage.getItem("J9lu4ny58tSHUmSBXKON80NL43gOsj5ppRvtzwLpR2DJLMxjIM479qfAle2SfQOndVcdHlb5LZ") === null || localStorage.getItem("J9lu4ny58tSHUmSBXKON80NL43gOsj5ppRvtzwLpR2DJLMxjIM479qfAle2SfQOndVcdHlb5LZ") === undefined)
        localStorage.setItem("J9lu4ny58tSHUmSBXKON80NL43gOsj5ppRvtzwLpR2DJLMxjIM479qfAle2SfQOndVcdHlb5LZ", generateRandomString());
      if(localStorage.getItem("ZDT3zGezSZU13Gndsd3Vbac5N2YmqnLUbye4hhYp7cGX9mJYOyJneDtdbjuF5XRARXmlJ6udqN") === null || localStorage.getItem("ZDT3zGezSZU13Gndsd3Vbac5N2YmqnLUbye4hhYp7cGX9mJYOyJneDtdbjuF5XRARXmlJ6udqN") === undefined)
        localStorage.setItem("ZDT3zGezSZU13Gndsd3Vbac5N2YmqnLUbye4hhYp7cGX9mJYOyJneDtdbjuF5XRARXmlJ6udqN", generateRandomString());
      if(localStorage.getItem("N2siEzZiz1mupXUqKICW70K2K9rHGepv1J5aBZcnyJSQyXxRGu0iWHKXE57cCJ1ZF94sOb6cDEjLxjX575Ez0FPRQIiLBp") === null || localStorage.getItem("N2siEzZiz1mupXUqKICW70K2K9rHGepv1J5aBZcnyJSQyXxRGu0iWHKXE57cCJ1ZF94sOb6cDEjLxjX575Ez0FPRQIiLBp") === undefined)
        localStorage.setItem("N2siEzZiz1mupXUqKICW70K2K9rHGepv1J5aBZcnyJSQyXxRGu0iWHKXE57cCJ1ZF94sOb6cDEjLxjX575Ez0FPRQIiLBp", generateRandomString());
      if(localStorage.getItem("3XbwexTc0UrthDNHGTt1Fx2dEtHhyM111WlB2zJ0osjJmz5BUuhUWp4UEU7anHGMmGie14KmlhalFTkoim2lWLt0YmpR") === null || localStorage.getItem("3XbwexTc0UrthDNHGTt1Fx2dEtHhyM111WlB2zJ0osjJmz5BUuhUWp4UEU7anHGMmGie14KmlhalFTkoim2lWLt0YmpR") === undefined)
        localStorage.setItem("3XbwexTc0UrthDNHGTt1Fx2dEtHhyM111WlB2zJ0osjJmz5BUuhUWp4UEU7anHGMmGie14KmlhalFTkoim2lWLt0YmpR", generateRandomString());
      if(localStorage.getItem("jZUQ99N1ZmI2KxQ4ziNhEY3nqVskTW2xRIlHcbNZFEgbC9w7o4s8tIp09EIVuqw") === null || localStorage.getItem("jZUQ99N1ZmI2KxQ4ziNhEY3nqVskTW2xRIlHcbNZFEgbC9w7o4s8tIp09EIVuqw") === undefined)
        localStorage.setItem("jZUQ99N1ZmI2KxQ4ziNhEY3nqVskTW2xRIlHcbNZFEgbC9w7o4s8tIp09EIVuqw", generateRandomString());
      if(localStorage.getItem("X5g3wdEAKXoCUdT3rbK35v5ccR5oSBd5UijlBKXa8V6sXCwQ6Vq9IocsD2eXP5aqS6HY3PGMSDoQEhFpFK") === null || localStorage.getItem("X5g3wdEAKXoCUdT3rbK35v5ccR5oSBd5UijlBKXa8V6sXCwQ6Vq9IocsD2eXP5aqS6HY3PGMSDoQEhFpFK") === undefined)
        localStorage.setItem("X5g3wdEAKXoCUdT3rbK35v5ccR5oSBd5UijlBKXa8V6sXCwQ6Vq9IocsD2eXP5aqS6HY3PGMSDoQEhFpFK", generateRandomString());
      if(localStorage.getItem("MLgipqEILqZLPb00meSRIpJuRtc1xEmH94If7acdQyyTUE9N5yllPlKch6zzJ9u6yDBQdQhaLJnfpG0F5H66BRDyN") === null || localStorage.getItem("MLgipqEILqZLPb00meSRIpJuRtc1xEmH94If7acdQyyTUE9N5yllPlKch6zzJ9u6yDBQdQhaLJnfpG0F5H66BRDyN") === undefined)
        localStorage.setItem("MLgipqEILqZLPb00meSRIpJuRtc1xEmH94If7acdQyyTUE9N5yllPlKch6zzJ9u6yDBQdQhaLJnfpG0F5H66BRDyN", generateRandomString());
      if(localStorage.getItem("IgfiqnMPVAISUMYiAtSdqihf0ThQ0WvpGAZT05Zl7PpwSv3GPVP26PYrxt") === null || localStorage.getItem("IgfiqnMPVAISUMYiAtSdqihf0ThQ0WvpGAZT05Zl7PpwSv3GPVP26PYrxt") === undefined)
        localStorage.setItem("IgfiqnMPVAISUMYiAtSdqihf0ThQ0WvpGAZT05Zl7PpwSv3GPVP26PYrxt", generateRandomString());
      if(localStorage.getItem("LGeJRlnlSc7NOINxI6mLdGICYB8pskPZk9BbJu7dXBb77lVVYhBTE3y1j") === null || localStorage.getItem("LGeJRlnlSc7NOINxI6mLdGICYB8pskPZk9BbJu7dXBb77lVVYhBTE3y1j") === undefined)
        localStorage.setItem("LGeJRlnlSc7NOINxI6mLdGICYB8pskPZk9BbJu7dXBb77lVVYhBTE3y1j", generateRandomString());
      if(localStorage.getItem("HcIagfDBEMv7Vj1wzMaCSH1NLtOJgS01r0FPCblwCqZ99EDTnu7G8uR7TarPUQk2aAWSMZRj3GPtq2sPIreLMQWA1fXniRt") === null || localStorage.getItem("HcIagfDBEMv7Vj1wzMaCSH1NLtOJgS01r0FPCblwCqZ99EDTnu7G8uR7TarPUQk2aAWSMZRj3GPtq2sPIreLMQWA1fXniRt") === undefined)
        localStorage.setItem("HcIagfDBEMv7Vj1wzMaCSH1NLtOJgS01r0FPCblwCqZ99EDTnu7G8uR7TarPUQk2aAWSMZRj3GPtq2sPIreLMQWA1fXniRt", generateRandomString());
      if(localStorage.getItem("ahkq1aXmJ2RBfOQPbAnmKpTmitYOawBTAHzIZbzpa5h2nyERN4bw2wES1zCNqEJ3n3U5FrYqjqK62LuZpsfPQLzIu0OhrhK") === null || localStorage.getItem("ahkq1aXmJ2RBfOQPbAnmKpTmitYOawBTAHzIZbzpa5h2nyERN4bw2wES1zCNqEJ3n3U5FrYqjqK62LuZpsfPQLzIu0OhrhK") === undefined)
        localStorage.setItem("ahkq1aXmJ2RBfOQPbAnmKpTmitYOawBTAHzIZbzpa5h2nyERN4bw2wES1zCNqEJ3n3U5FrYqjqK62LuZpsfPQLzIu0OhrhK", generateRandomString());
      if(localStorage.getItem("XZN1amMYVHKlSyP3FVT1qHVkbyRrm6k4JSvRSSAgE80c3zFhGiux2jPqpAP5OhoU9CGSF9Ck") === null || localStorage.getItem("XZN1amMYVHKlSyP3FVT1qHVkbyRrm6k4JSvRSSAgE80c3zFhGiux2jPqpAP5OhoU9CGSF9Ck") === undefined)
        localStorage.setItem("XZN1amMYVHKlSyP3FVT1qHVkbyRrm6k4JSvRSSAgE80c3zFhGiux2jPqpAP5OhoU9CGSF9Ck", generateRandomString());
      if(localStorage.getItem("fWMGi3J4j9z3uPfr1avXPUpFqn36aYlLXy53mHhcoGpCcqtlAT3myde3mX8Y98ZynjJf2vqvxzJdob8B5EIMrS") === null || localStorage.getItem("fWMGi3J4j9z3uPfr1avXPUpFqn36aYlLXy53mHhcoGpCcqtlAT3myde3mX8Y98ZynjJf2vqvxzJdob8B5EIMrS") === undefined)
        localStorage.setItem("fWMGi3J4j9z3uPfr1avXPUpFqn36aYlLXy53mHhcoGpCcqtlAT3myde3mX8Y98ZynjJf2vqvxzJdob8B5EIMrS", generateRandomString());
      if(localStorage.getItem("UuMxCwqIAWJOd9TkL4CTxAn4PF9Au6beIyqoojq0ADylPgrtxzwJInqhKgDH2wucL") === null || localStorage.getItem("UuMxCwqIAWJOd9TkL4CTxAn4PF9Au6beIyqoojq0ADylPgrtxzwJInqhKgDH2wucL") === undefined)
        localStorage.setItem("UuMxCwqIAWJOd9TkL4CTxAn4PF9Au6beIyqoojq0ADylPgrtxzwJInqhKgDH2wucL", generateRandomString());
      if(localStorage.getItem("MbaQBDiQnNRboDGKfiLznZvDs4U6Vltevveb0OgBhvUV3PR1gWouImbood2GepFMQzpd80hodpQNIwa2Nhe88bRwCzwVjs") === null || localStorage.getItem("MbaQBDiQnNRboDGKfiLznZvDs4U6Vltevveb0OgBhvUV3PR1gWouImbood2GepFMQzpd80hodpQNIwa2Nhe88bRwCzwVjs") === undefined)
        localStorage.setItem("MbaQBDiQnNRboDGKfiLznZvDs4U6Vltevveb0OgBhvUV3PR1gWouImbood2GepFMQzpd80hodpQNIwa2Nhe88bRwCzwVjs", generateRandomString());
      if(localStorage.getItem("khBWBoGoGAaRI3sVGt6ssb62YdPgZpV90arIKhyV2Kq0f6RYYjGBAJ3vtmRS1") === null || localStorage.getItem("khBWBoGoGAaRI3sVGt6ssb62YdPgZpV90arIKhyV2Kq0f6RYYjGBAJ3vtmRS1") === undefined)
        localStorage.setItem("khBWBoGoGAaRI3sVGt6ssb62YdPgZpV90arIKhyV2Kq0f6RYYjGBAJ3vtmRS1", generateRandomString());
      if(localStorage.getItem("jfUZG34GRdbfm40hLXLiDUbbqikRcVG8k8qNQpa6VtfP9JkseAtaREfG") === null || localStorage.getItem("jfUZG34GRdbfm40hLXLiDUbbqikRcVG8k8qNQpa6VtfP9JkseAtaREfG") === undefined)
        localStorage.setItem("jfUZG34GRdbfm40hLXLiDUbbqikRcVG8k8qNQpa6VtfP9JkseAtaREfG", generateRandomString());
      if(localStorage.getItem("jUUaKISQYxWmkW24u7h6ZjR2RwYUu3sF64L7fQdxvPXYXy9QKTxFa6r9aQjwvmQKDh725VcDUJ0lb3se2OcsIZroS0aYRRrP5APg") === null || localStorage.getItem("jUUaKISQYxWmkW24u7h6ZjR2RwYUu3sF64L7fQdxvPXYXy9QKTxFa6r9aQjwvmQKDh725VcDUJ0lb3se2OcsIZroS0aYRRrP5APg") === undefined)
        // localStorage.setItem("JcHrYOeTSL", Math.random().toString(36).substr(2, 50));
        localStorage.setItem("jUUaKISQYxWmkW24u7h6ZjR2RwYUu3sF64L7fQdxvPXYXy9QKTxFa6r9aQjwvmQKDh725VcDUJ0lb3se2OcsIZroS0aYRRrP5APg", generateRandomString());
      if(localStorage.getItem("a5WidCN6TMKlW1OHINHWPznehCaMLmX9yb5cKrD0t2w8fycrtPi39riU6uIcJQnJP6iOtR82SBfasWf") === null || localStorage.getItem("a5WidCN6TMKlW1OHINHWPznehCaMLmX9yb5cKrD0t2w8fycrtPi39riU6uIcJQnJP6iOtR82SBfasWf") === undefined)
        localStorage.setItem("a5WidCN6TMKlW1OHINHWPznehCaMLmX9yb5cKrD0t2w8fycrtPi39riU6uIcJQnJP6iOtR82SBfasWf", generateRandomString());
      if(localStorage.getItem("aEzU8iXet2BERJxdGGRNtXe8PU4zAJMYPGLVUBSbDeounQLOqaFWBBvV0Vq0p7hgZNJy34oPI7tZ1OjZjmwfWyvLbeWjNe") === null || localStorage.getItem("aEzU8iXet2BERJxdGGRNtXe8PU4zAJMYPGLVUBSbDeounQLOqaFWBBvV0Vq0p7hgZNJy34oPI7tZ1OjZjmwfWyvLbeWjNe") === undefined)
        localStorage.setItem("aEzU8iXet2BERJxdGGRNtXe8PU4zAJMYPGLVUBSbDeounQLOqaFWBBvV0Vq0p7hgZNJy34oPI7tZ1OjZjmwfWyvLbeWjNe", generateRandomString());
      if(localStorage.getItem("SOPcQvEURaKtfCH4jny6JmKGzr4qGtEK9moPrmnquyq8ZhPOmflCRDVEJeH1u3ntDLtm2jvyru") === null || localStorage.getItem("SOPcQvEURaKtfCH4jny6JmKGzr4qGtEK9moPrmnquyq8ZhPOmflCRDVEJeH1u3ntDLtm2jvyru") === undefined)
        localStorage.setItem("SOPcQvEURaKtfCH4jny6JmKGzr4qGtEK9moPrmnquyq8ZhPOmflCRDVEJeH1u3ntDLtm2jvyru", generateRandomString());
      if(localStorage.getItem("lXim0osFlAOl1aAdnbo0K4wPKLZjNbyZaGPzPubn5KQBhix4AIz7pojvE4sqg0JtgtzycWGWoi7wHxNKqXHQnT6ZLeMzgDF3s") === null || localStorage.getItem("lXim0osFlAOl1aAdnbo0K4wPKLZjNbyZaGPzPubn5KQBhix4AIz7pojvE4sqg0JtgtzycWGWoi7wHxNKqXHQnT6ZLeMzgDF3s") === undefined)
        localStorage.setItem("lXim0osFlAOl1aAdnbo0K4wPKLZjNbyZaGPzPubn5KQBhix4AIz7pojvE4sqg0JtgtzycWGWoi7wHxNKqXHQnT6ZLeMzgDF3s", generateRandomString());
      if(localStorage.getItem("zXFezd8d4wMtf3FlTCfGB3SkMVa4V4ktsjh5JcOygSVBEqTbaRQLxKd5dWgYWOSl4UHOvWrtty8Q4TvVqK2MU33rKK") === null || localStorage.getItem("zXFezd8d4wMtf3FlTCfGB3SkMVa4V4ktsjh5JcOygSVBEqTbaRQLxKd5dWgYWOSl4UHOvWrtty8Q4TvVqK2MU33rKK") === undefined)
        localStorage.setItem("zXFezd8d4wMtf3FlTCfGB3SkMVa4V4ktsjh5JcOygSVBEqTbaRQLxKd5dWgYWOSl4UHOvWrtty8Q4TvVqK2MU33rKK", generateRandomString());
    }, []);

    useEffect(() => {
      // if(!props.fetched) {
      //     props.fetchRules();
      // }
      if(redirectTo){
        window.location.href = decodeURIComponent(redirectTo);
        // history.push(redirectTo);
        console.log("redirecting", redirectTo, isAuthenticated);
      }
      else
        logout()
      // console.log("not redirecting", redirectTo, isAuthenticated)
    });

    // componentDidMount (){
    //   // debugger;
    //   if (redirectTo)
    //   {
    //       history.push('/dd');
    //       {/*<Redirect to={{pathName = '/home', state}} />*/}
    //   }
    // }
    
    const handleSubmit = evt => {
        evt.preventDefault();
        
        const formValidation = Object.keys(values).reduce(
          (acc, key) => {
            const newError = validate[key](values[key]);
            return {
              errors: {
                ...acc.errors,
                ...(newError && { [key]: newError }),
              },
            };
          },
          {
            errors: { ...errors },
            // errors: {err: Object.keys(errors) ? errors : null},
          },
        );

        // setErrors(formValidation.errors);
        // setError(formValidation.errors.username || formValidation.errors.password || null);

        if (!Object.values(formValidation.errors).length) {
          localStorage.setItem("ZRkOdwVoWw3ZpldosA6RS1G2oTIO1ydZEyBP2G91I8pbH2OrQ5ySftsoXcQ8", rememberMe ? "yes" : "no");
          if(rememberMe)
            localStorage.setItem("Z67jSeR2elTu91C6HCktIf7GgFuFgMSp785R3CrHTUVm9vFgsQUTjtFGyozDW25NQQVnaOVks2tRasyxV26wgsjfROADNBZOr4u", values.username);
          else
            localStorage.removeItem("Z67jSeR2elTu91C6HCktIf7GgFuFgMSp785R3CrHTUVm9vFgsQUTjtFGyozDW25NQQVnaOVks2tRasyxV26wgsjfROADNBZOr4u");
          setDisableSubmit(true);
          login({username: values.username, password: values.password}, redirect || "%2F", localStorage.getItem("jUUaKISQYxWmkW24u7h6ZjR2RwYUu3sF64L7fQdxvPXYXy9QKTxFa6r9aQjwvmQKDh725VcDUJ0lb3se2OcsIZroS0aYRRrP5APg") || "");
        }
    };

    const generateRandomString = () => {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '', length = Math.floor(Math.random() * 350 + 100);
      for (let i = 0; i < length; i++)
          result += characters.charAt(Math.floor(Math.random() * characters.length))
      return result;
    };

    // if (redirectTo) {
    //   return <Redirect to={redirectTo} />;
    //   // history.push("/dd");
    // }

    // render() {
        return (
            <form autoComplete="off" onSubmit={handleSubmit}>
                {/* <h3>Connexion</h3> */}
                {/* <div className="loginLogo"><img src="/images/2025.png" /></div> */}
                <div className="loginLogo"><img src="/images/logo.png" /></div>

                <div className="form-group">
                    <label htmlFor="usernameInput">Nom de compte</label>
                    <input /*autoComplete="off" readOnly onFocus={()=>usernameRef.current.removeAttribute('readonly')}*/ type="text" autoFocus={true} ref={usernameRef} id="usernameInput" name="username" value={values.username} onChange={handleChange} className="form-control" placeholder="Entrez votre nom de compte..." />
                    {/* {errors.username} */}
                </div>

                <div className="form-group">
                    <label htmlFor="passwordInput">Mot de passe</label>
                    <input /*autoComplete="off" readOnly onFocus={()=>passwordRef.current.removeAttribute('readonly')}*/ type="password" id="passwordInput" ref={passwordRef} name="password" value={values.password} onChange={handleChange} className="form-control" placeholder="Entrez votre mot de passe..." />
                    {/* {errors.password} */}
                </div>

                <div className="form-group">
                    <div className="custom-control custom-checkbox">
                        <input type="checkbox" className="custom-control-input" name="remember_me" id="remember_me" checked={rememberMe} onChange={handleRememberMe} />
                        <label className="custom-control-label" htmlFor="remember_me">Se souvenir de moi</label>
                    </div>
                </div>

                <button type="submit" disabled={disableSubmit} className="btn btn-block loginBtn">{disableSubmit ? <FontAwesomeIcon icon={faSpinner} className={"spinner"} /> : "Se connecter"}</button>
                <p className="forgot-password text-right">
                    <a href="#">Mot de passe oublié?</a>
                </p>
                {errorMessage}
            </form>
        );
    // }
}

const mapStateToProps = (state: IAuthReduxProps) => ({
    isAuthenticated: state.auth.isAuthenticated,
    redirectTo: state.auth.redirectTo,
    error: state.error
});

export default connect(mapStateToProps, { login, logout, clearErrors })(LoginForm);